import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Chip,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { LibraryBooksRounded } from "@mui/icons-material";
import PageHeader from "../components/page-header";
import { Dialogs } from "../components/dialogs";
import StickyHeadTable, { Column } from "../components/table";
import { Livraria, LivrariaType } from "../types/general";
import { ViewModelLivraria } from "../viewmodel/viewmodel-livraria";

function LivrariasPage() {
  const {
    dialog,
    handleDeleteLivraria,
    showWarning,
    handleActionLivraria,
    showConfirmation,
    ...viewModel
  } = ViewModelLivraria();

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState<LivrariaType>("OTHERS");

  const handleOpen = () => {
    setEditMode(false);
    setName("");
    setDescription("");
    setType("OTHERS");
    setOpen(true);
  };

  const handleEdit = (id: number) => {
    const livraria = viewModel.livrarias.data.find((t) => t.id === id);
    if (livraria) {
      setEditMode(true);
      setName(livraria.name);
      setDescription(livraria.description);
      setType(livraria.type);
      viewModel.selectLivraria(livraria);
      setOpen(true);
    }
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      showWarning({
        title: "Erro",
        message: "O nome da disciplina é obrigatório"
      });
      return;
    }
    if (!description.trim()) {
      showWarning({
        title: "Erro",
        message: "A descrição é obrigatória"
      });
      return;
    }
    setOpen(false);
    editMode && viewModel.selectedLivraria?.id
      ? handleActionLivraria({
        id: viewModel.selectedLivraria.id, name, description, type
      }, 'update')
      : handleActionLivraria({
        name, description, type
      } as Livraria, 'add');
  };

  const handleDelete = (id: number) => {
    const livraria = viewModel.livrarias.data.find((t) => t.id === id);
    showConfirmation({
      title: "Confirmar Eliminação",
      message: `Tem a certeza que deseja eliminar a disciplina "${livraria?.name}"? Esta ação não pode ser desfeita.`,
      onConfirm: () => handleDeleteLivraria(id),
    });
  };

  const columns: Column<Livraria>[] = [
    { id: "id", label: "ID", minWidth: 100 },
    { id: "name", label: "Nome", minWidth: 300 },
    {
      id: "description",
      label: "Descrição",
      minWidth: 400,
    },
    {
      id: "type",
      label: "Tipo",
      minWidth: 120,
      renderCell: (row) => (
        <Chip
          label={row.type === "SNE" ? "SNE" : "Outros"}
          color={row.type === "SNE" ? "primary" : "default"}
          size="small"
        />
      ),
    },
    {
      id: "actions",
      label: "Ações",
      minWidth: 190,
      renderCell: (row) => (
        <Box>
          <Tooltip title="Editar" arrow>
            <IconButton
              size="small"
              onClick={() => handleEdit(row.id!)}
              color="primary"
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {/* <Tooltip title="Eliminar" arrow>
            <IconButton
              size="small"
              color="error"
              onClick={() => handleDelete(row.id!)}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip> */}
          <Tooltip title="Ver Livros" arrow>
            <Button
              size="small"
              color="success"
              onClick={() => viewModel.goToLivros(row.id!)}
            >
              Livros
            </Button>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <PageHeader
        icon={<LibraryBooksRounded />}
        color="#10B981"
        title="Gestão de Disciplinas"
        actions={
          <Button variant="contained" onClick={handleOpen}>
            Nova Disciplina
          </Button>
        }
      />

      <StickyHeadTable
        columns={columns}
        rows={viewModel.livrarias.data}
        getRowId={(row) => row.id!}
        pagination={{
          totalData: viewModel.livrarias.pagination.totalData,
          totalPages: viewModel.livrarias.pagination.totalPages,
          currentPage: viewModel.livrarias.pagination.currentPage,
          onPageChange: (newPage) => {
            viewModel.fetchLivrarias(newPage);
          },
          onRowsPerPageChange: () => { },
        }}
      />

      {/* Create/Edit Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editMode ? "Editar Disciplina" : "Nova Disciplina"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nome da Disciplina"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Descrição"
            fullWidth
            multiline
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            sx={{ mb: 2 }}
          />
          <FormControl fullWidth>
            <InputLabel>Tipo</InputLabel>
            <Select
              value={type}
              label="Tipo"
              onChange={(e) => setType(e.target.value as LivrariaType)}
            >
              <MenuItem value="SNE">SNE</MenuItem>
              <MenuItem value="OTHERS">Outros</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button onClick={handleSubmit} variant="contained">
            {editMode ? "Actualizar" : "Criar"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialogs{...dialog} />
    </Container>
  );
}

export default LivrariasPage;
